<template>
  <BModal hide-header hide-footer body-class="rounded-lg p-5 bg-white" :visible="visible" @hide="close">
    <img
      class="w-50 d-block mx-auto mb-4"
      :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
      :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
    />

    <div class="btn-group w-100">
      <BushelBtn :variant="tab == 'login' ? 'success' : 'primary'" @click="tab = 'login'"> Login </BushelBtn>
      <BushelBtn :variant="tab == 'signup' ? 'success' : 'primary'" @click="tab = 'signup'"> Register </BushelBtn>
    </div>
    <div>
      <div v-if="tab == 'login'" class="px-5 pb-5 pt-4 bg-white shadow border rounded-lg mt-4">
        <p v-if="tab == 'login'" class="text-center text-sm">
          Log In to your existing Apex Trading buyer account to view your custom menu and place an order. If you don’t have an account please
          Register.
        </p>
        <LoginForm @logged-in="$emit('loggedIn', $event)" />
      </div>
      <div v-if="tab == 'signup'" class="p-3 bg-white shadow border rounded-lg mt-4">
        <p v-if="tab == 'signup'" class="text-center text-sm">
          Please register for a buyer account on Apex Trading. If your email exists in the seller's system you will be able to order immediately. If
          not, you will be able to order once our team approves your account which usually takes 1-2 business hours.
        </p>
        <RegisterForm @logged-in="$emit('loggedIn', $event)" />
      </div>
    </div>
  </BModal>
</template>
<script>
import LoginForm from "./LoginForm.vue";
import RegisterForm from "./RegisterForm.vue";

export default {
  components: {
    LoginForm,
    RegisterForm,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["loggedIn", "hide"],
  data() {
    return {
      tab: "login",
      industry: "cannabis",
    };
  },
  methods: {
    close() {
      this.$emit("hide", true);
    },
  },
};
</script>
<style scoped>
.active-tab {
  border-bottom: var(--secondary) 2px solid;
  font-weight: 900;
}
</style>
